import * as Yup from 'yup';
import { useTranslation } from '../../../hooks/useTranslation';

type TFunction = ReturnType<typeof useTranslation>['t'];

const REQUEST_SCHEMA = (t: TFunction) => {
    return Yup.object().shape({
        dates: Yup.object()
            .shape({
                startDate: Yup.object().required(),
                endDate: Yup.object().nullable(),
            })
            .required(),
        leaveDescriptionRequired: Yup.boolean(),
        description: Yup.string()
            .trim()
            .max(250, t('validationMessages.REQUEST_SCHEMA.description.max'))
            .when('leaveDescriptionRequired', {
                is: true,
                then: schema => schema.required(t('validationMessages.REQUEST_SCHEMA.description.required')),
            }),
        leaveType: Yup.object().shape({
            label: Yup.string().required(t('validationMessages.REQUEST_SCHEMA.leaveType.label.required')),
            value: Yup.string().required(t('validationMessages.REQUEST_SCHEMA.leaveType.value.required')),
        }),
    });
};

export default REQUEST_SCHEMA;
